import { ImportConfigurationApi } from './import-configuration-api';
import {
  SheetMappingRequest,
  SheetMappingListResponse,
  SheetMappingDetailResponse,
  SheetMappingMutationResponse,
  SheetMappingDeleteResponse,
  ColumnMappingRequest,
  ColumnMappingListResponse,
  ColumnMappingMutationResponse,
  ColumnMappingDeleteResponse,
} from '../types/import-configuration-types';

/**
 * Import Configuration Repository
 * Acts as an abstraction layer between use cases and API
 */
export class ImportConfigurationRepository {
  constructor(private readonly api: ImportConfigurationApi) {}

  // ============================================================================
  // Sheet Mappings
  // ============================================================================

  /**
   * Get all sheet mappings
   */
  async getSheetMappings(): Promise<SheetMappingListResponse> {
    return this.api.getSheetMappings();
  }

  /**
   * Get a single sheet mapping with its column mappings
   */
  async getSheetMappingById(mappingId: number): Promise<SheetMappingDetailResponse> {
    return this.api.getSheetMappingById(mappingId);
  }

  /**
   * Create or update a sheet mapping
   */
  async saveSheetMapping(request: SheetMappingRequest): Promise<SheetMappingMutationResponse> {
    return this.api.saveSheetMapping(request);
  }

  /**
   * Delete a sheet mapping
   */
  async deleteSheetMapping(mappingId: number): Promise<SheetMappingDeleteResponse> {
    return this.api.deleteSheetMapping(mappingId);
  }

  // ============================================================================
  // Column Mappings
  // ============================================================================

  /**
   * Get column mappings for a sheet
   */
  async getColumnMappings(sheetMappingId: number): Promise<ColumnMappingListResponse> {
    return this.api.getColumnMappings(sheetMappingId);
  }

  /**
   * Create or update a column mapping
   */
  async saveColumnMapping(request: ColumnMappingRequest): Promise<ColumnMappingMutationResponse> {
    return this.api.saveColumnMapping(request);
  }

  /**
   * Delete a column mapping
   */
  async deleteColumnMapping(columnId: number): Promise<ColumnMappingDeleteResponse> {
    return this.api.deleteColumnMapping(columnId);
  }
}
